<template>
  <div>
    <iRow
      v-for="(value, key) in version.objectChanges"
      :key="key"
      class="expand-row">
      <span class="expand-key">{{ table.i18nAttr(key) }}: </span>
      <span class="expand-value">
        {{ formatColumn(key, value[0]) }} &harr; {{ formatColumn(key, value[1]) }}
      </span>
    </iRow>
  </div>
</template>

<script>
export default {
  props: {
    version: { type: Object, required: true },
  },
  inject: ['table'],
  methods: {
    formatColumn(key, value) {
      const config = this.table.attributesBy[key];
      if (!config) return value;
      const { formatterFn } = config;
      return formatterFn ?
        formatterFn(value, { attribute: config, data: this.version.object })
        : value;
    },
  },
};
</script>

<style scoped>
  .expand-row{
    margin-bottom: 16px;
  }
</style>
